import removeMultipleSpaces from "@mobi/utils/formatters/removeMultipleSpaces"

export const handleChange = (event, field, changeMethod) => {
  field.onChange(event)
  changeMethod(event)
}

export const handleBlur = (event, field, blurMethod) => {
  field.onBlur()
  const clearEvent = {
    ...event,
    target: {
      ...event.target,
      value: removeMultipleSpaces(field.value),
    },
  }

  if (field.value !== clearEvent.target.value) {
    field.onChange(clearEvent)
  }

  if (blurMethod) {
    blurMethod(clearEvent)
  }
}
